/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- ARTICLE SENTIMENT V2 ANALYTICS - REACTION ADDED/TOTAL CLICKS REPORT : STYLES --------------- ++++++++++ */
export default {
    totalclicksreport: {
        marginBottom: pxToEm(16)
    }
};
